export default __webpack_public_path__ + "static/media/DSC_0549.a4c3fca7.jpg";